import React from 'react'
import { AiFillCheckCircle, AiOutlineCheckCircle } from 'react-icons/ai'

const CheckIcon = ({onClick, status, trueString, falseColor="red"}) => {

    const icon = () => {
      if (trueString) {
        if (status == trueString) return <AiFillCheckCircle size={25} color={"green"}/>
        return <AiOutlineCheckCircle size={25} color={falseColor}/>
      } 
      if (status) return <AiFillCheckCircle size={25} color={"green"}/>
      return <AiOutlineCheckCircle size={25} color={falseColor}/>
    }
  
    return (
      <div > 
          <div onClick={onClick}>
              {icon()}
          </div>   
      </div>
    )
}

export default CheckIcon
